import { render, staticRenderFns } from "./InputWrapperTitle.vue?vue&type=template&id=5f2b4ce2&scoped=true"
import script from "./InputWrapperTitle.vue?vue&type=script&lang=ts"
export * from "./InputWrapperTitle.vue?vue&type=script&lang=ts"
import style0 from "./InputWrapperTitle.vue?vue&type=style&index=0&id=5f2b4ce2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2b4ce2",
  null
  
)

export default component.exports